<template>

    <div class="fixed left-0 top-0 right-0 sm:top-4 sm:right-4 sm:left-auto" style="z-index: 60;" v-if="active">

        <div class="bg-neutral-800 sm:rounded px-3 py-2 w-full md:max-w-md flex items-center justify-between cursor-pointer" @click="handleAction">
            <div class="text-white" v-html="message"></div>
        </div>

    </div>

</template>

<script>
import {
  mapActions,
} from 'vuex';

export default {
  name: 'Snackbar',
  computed: {
    active() {
      return this.$store.state.ui.snackbar.active || false;
    },
    message() {
      return this.$store.state.ui.snackbar.message || '';
    },
    action() {
      return this.$store.state.ui.snackbar.action || null;
    },
    duration() {
      return this.$store.state.ui.snackbar.duration || null;
    },
    type() {
      return this.$store.state.ui.snackbar.type || null;
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  methods: {
    ...mapActions({
      setSnackbar: 'ui/snackbar',
      snackbarClose: 'ui/snackbarClose',
    }),
    handleClose() {
      this.snackbarClose();
      clearTimeout(this.timer);
      this.timer = null;
    },
    handleAction() {
      if (this.action && this.action.click) {
        this.action.click();
      }

      this.handleClose();
    },
  },
  watch: {
    active: {
      immediate: true,
      handler() {
        if (this.active && this.duration) {
          this.timer = setTimeout(this.handleClose, this.duration);
        }
      },
    }
  }
};
</script>

<style scoped lang="scss">

</style>
